import * as types from './types';

// TODO: setear el userType segun el siteId.

const getPlansInfo = () => ({
  type: types.FETCH_PLANS_INFO,
  meta: {
    async: true,
    blocking: false,
    api: 'ecommerce',
    path: `/ecommerce/api/v1/products`,
    method: 'GET',
    query: { userType: 'zonademand' }
  }
});

export { getPlansInfo };
